import { __decorate } from "tslib";
import _ from 'lodash';
import { provide } from '@/inversify.config';
import qs from 'qs';
export const TaskAssignServiceSymbol = Symbol.for('TaskAssignService');
let TaskAssignService = class TaskAssignService {
    constructor() {
        this.state = {
            taskAssignDialog: {
                isOpen: false,
            },
            reassignDialog: {
                isOpen: false,
            },
            basicInfo: {},
            isLoadingReviewPanel: false,
            savingInfo: {
                saving: 0,
                saved: 0,
            },
        };
    }
    get query() {
        const search = window.location.search.substring(1);
        return qs.parse(search);
    }
    get currentTaskId() {
        return _.get(this.query, 'taskId');
    }
    get taskAssignDialog() {
        return this.state.taskAssignDialog;
    }
    get reassignDialog() {
        return this.state.reassignDialog;
    }
    get taskBasicInfo() {
        return this.state.basicInfo;
    }
    get isLoadingReviewPanel() {
        return this.state.isLoadingReviewPanel;
    }
    get savingInfo() {
        return this.state.savingInfo;
    }
    setTaskBasicInfo(info) {
        this.state.basicInfo = info;
    }
    openTaskAssignDialog() {
        this.state.taskAssignDialog.isOpen = true;
    }
    closeTaskAssignDialog() {
        this.state.taskAssignDialog.isOpen = false;
    }
    openReassignDialog() {
        this.state.reassignDialog.isOpen = true;
    }
    closeReassignDialog() {
        this.state.reassignDialog.isOpen = false;
    }
    beginLoadingReviewPanel() {
        this.state.isLoadingReviewPanel = true;
    }
    endLoadingReviewPanel() {
        this.state.isLoadingReviewPanel = false;
    }
    savingField() {
        this.state.savingInfo.saving++;
    }
    savedField() {
        this.state.savingInfo.saved++;
    }
};
TaskAssignService = __decorate([
    provide(TaskAssignServiceSymbol)
], TaskAssignService);
export { TaskAssignService };
